<template>
  <footer class="rcv__footer">
    <div class="container">
      <div class="rcv__footer-row">
        <div v-if="showBackButton" class="rcv__footer-left">
          <a href="#" class="rcv__btn rcv__btn__primary" role="button" aria-label="Go back to the previous page"
            @click.prevent="$emit('back-clicked')">
            <span> <i>&lt;</i>  Back</span>
          </a>
        </div>
        <div class="rcv__footer-right">
          <a v-if="currentState === 'initial'" href="javascript:void(0)" class="rcv__btn rcv__btn__secondary"
            role="button" aria-label="Start ranking" @click="start">
           <span>{{ ballotData.startButton }}</span>
          </a>

          <a v-else-if="currentState === 'rankingStarted'" href="javascript:void(0)"
            class="rcv__btn rcv__btn__secondary" role="button" aria-label="Start Ranking"
            @click="proceedToSubmit">
            <span>{{ ballotData.startRankingButton }}</span>
          </a>

          <a v-else-if="currentState === 'readyToSubmit'" href="javascript:void(0)"
            class="rcv__btn rcv__btn__secondary" role="button" aria-label="Submit Ballot"
            @click="submitBallot">
            <span>{{ ballotData.submitBallotButton }}</span>
          </a>
          <a v-else-if="currentState === 'submittedError'" href="javascript:void(0)"
            class="rcv__btn rcv__btn__secondary" role="button" aria-label="Submit Ballot"
            @click="handleSeeErrors">
            <span>{{ ballotData.seeErrorsButton }}</span>
          </a>
          <a v-else-if="currentState === 'submittedSuccess'" href="javascript:void(0)"
            class="rcv__btn rcv__btn__secondary" role="button" aria-label="Submit Ballot" @click="success">
            <span>{{ ballotData.successButtonLabel }}</span>
          </a>
          <a v-else-if="currentState === 'seeNextError'" href="javascript:void(0)"
            class="rcv__btn rcv__btn__secondary" role="button" aria-label="Submit Ballot" @click="checkErrors">
            <span>{{ ballotData.seeNextErrorButton }}</span>
          </a>
          <a v-else-if="currentState === 'tryRankingAgain'" href="javascript:void(0)"
            class="rcv__btn rcv__btn__secondary" role="button" aria-label="Submit Ballot" @click="tryRanking">
            <span>{{ ballotData.tryRankingAgainButton }}</span>
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent",
  
  props: {
    ballotData: Object,
    currentState: {
      type: String,
      validator: val => ['initial', 'rankingStarted', 'readyToSubmit', 'submittedError','seeNextError', 'tryRankingAgain'].includes(val)
    },
    showBackButton: Boolean,
    isLastError: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    currentState(newVal) {
      const grid = document.getElementById('rcv__content');
      if (grid) {
        grid.style.display = newVal === 'initial' ? 'block' : 'none';
      }
    }
  },
  methods: {

    start() {
      const grid = document.getElementById('rcv__content');
      if (grid) {
        grid.style.display = 'none';
      }
      this.$emit('start-clicked');
    },
    proceedToSubmit() {
      this.$emit('proceed-clicked');
    },
    submitBallot() {
      this.$emit('submit-clicked');
    },
    handleSeeErrors() {
      this.$emit('see-errors-clicked');
    },
    success(){
      this.$emit('how-votes-counted-clicked');
    },
    checkErrors()
    {
      this.$emit('see-next-error-clicked');
    },
    tryRanking()
      {
        this.$emit('try-ranking-again');
      }
    
  }
};
</script>



// WEBPACK FOOTER //
// src/components/FooterComponent.vue